export function getBaseDomain() {
    return document.querySelector('[name="site-base-domain"]')?.value ?? '';
}
